import { useMemo } from 'react';

import {
  GeneratedGetDrawByProductIDsQuery,
  useGetProductsQuery,
} from '../../../types/generated';
import { checkoutGate } from '../utils/checkoutGate';
import { withWorksQuery } from '../utils/worksQuery';

type SetDraws = {
  data?: GeneratedGetDrawByProductIDsQuery;
  loading: boolean;
};

type SetCheckoutLink = {
  link: string | null;
  loading: boolean;
};

export const useSetCheckoutLink = (
  productIds: string[],
  draws: SetDraws,
): SetCheckoutLink => {
  const isSet = productIds.length > 1;
  const mainIds = productIds.slice(0, 1);

  const products = useGetProductsQuery({
    variables: { ids: [], shopifyIDs: mainIds, slugs: [] },
    skip: !isSet,
  });

  const product = products.data?.getProducts[0];
  const draw = draws.data?.getDrawByProductIDs.find((item) => {
    return item.productId === product?.shopifyId;
  });
  const loading = isSet && (products.loading || draws.loading);

  return useMemo(() => {
    if (!isSet || loading || !product) {
      return { link: null, loading };
    }

    if (!checkoutGate({ draw, product })) {
      return { link: null, loading };
    }

    return {
      link: withWorksQuery(`/checkout/${product.slug}`, productIds),
      loading,
    };
  }, [draw, isSet, loading, product, productIds]);
};
